import { LearningInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const getThumbnailListsAndTags: () => Promise<LearningInterface> = (): Promise<LearningInterface> => api.get('v1/learnings');
